(function () {
  'use strict';

  if (window.__boiProductPageInitRegistered) return;
  window.__boiProductPageInitRegistered = true;

  function readConfig() {
    var node = document.getElementById('boi-product-config');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedIso(select) {
    if (!select || select.selectedIndex < 0) return null;
    var option = select.options[select.selectedIndex];
    return option && option.dataset.iso ? String(option.dataset.iso).toUpperCase() : null;
  }

  var premiumPriceViews;
  function updatePremiumPrice(variant) {
    if (!variant) return;
    var target = document.querySelector('[data-boi-pdp-price]');
    var source = document.querySelector('[data-boi-pdp-price-variants]');
    if (!target || !source || target.dataset.variantId === String(variant.id)) return;
    if (!premiumPriceViews) {
      try { premiumPriceViews = JSON.parse(source.textContent); }
      catch (error) { return; }
    }
    var html = premiumPriceViews[String(variant.id)];
    if (typeof html !== 'string' || target.dataset.variantId === String(variant.id)) return;
    target.innerHTML = html;
    target.dataset.variantId = String(variant.id);
    document.dispatchEvent(new CustomEvent('boi:pdp-price-updated'));
  }

  function stripLeadingFlagEmojis(text) {
    return String(text || '').replace(/^(?:[\u{1F1E6}-\u{1F1FF}]{2}\s*)+/gu, '').trim();
  }

  function countryCodeToEmoji(iso) {
    return String(iso || '').toUpperCase().replace(/./g, function (character) {
      return String.fromCodePoint(character.charCodeAt(0) + 127397);
    });
  }

  function addOptionFlags(select) {
    Array.prototype.forEach.call(select.options, function (option) {
      var iso = String(option.dataset.iso || '').toUpperCase();
      if (!iso) return;
      var cleanLabel = option.dataset.cleanLabel || stripLeadingFlagEmojis(option.textContent);
      option.dataset.cleanLabel = cleanLabel;
      option.textContent = countryCodeToEmoji(iso) + ' ' + cleanLabel;
    });
  }

  function paintFlag(select) {
    if (!select || select.selectedIndex < 0) return;
    var option = select.options[select.selectedIndex];
    var iso = String(option.dataset.iso || '').toLowerCase();
    select.style.backgroundImage = iso ? "url('https://flagcdn.com/16x12/" + iso + ".png')" : '';
    option.textContent = option.dataset.cleanLabel || stripLeadingFlagEmojis(option.textContent);
  }

  function refreshCountrySelect() {
    var select = document.getElementById('country-select');
    if (!select) return;
    Array.prototype.forEach.call(select.options, function (option) {
      var cleanLabel = option.dataset.cleanLabel || stripLeadingFlagEmojis(option.textContent);
      option.dataset.cleanLabel = cleanLabel;
      option.textContent = cleanLabel;
    });
    addOptionFlags(select);
    paintFlag(select);
  }

  function setSelectByIso(select, iso) {
    if (!select || !iso) return false;
    var normalizedIso = String(iso).toUpperCase();
    var target = Array.prototype.find.call(select.options, function (option) {
      return String(option.dataset.iso || '').toUpperCase() === normalizedIso;
    });
    if (!target) return false;
    var changed = select.value !== target.value;
    if (changed) select.value = target.value;
    if (select.id === 'country-select') refreshCountrySelect();
    if (changed) select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function initShipping(config) {
    if (window.__productShippingInitDone) return;
    if (!window.BoiDelivery) {
      if (window.__boiProductDeliveryPending) return;
      window.__boiProductDeliveryPending = true;
      // Let the existing eager hero decode and paint before requesting the optional calculator.
      var image = document.querySelector('.boi-gallery__main-image');
      var decoded = image && image.decode ? image.decode().catch(function () {}) : Promise.resolve();
      decoded.then(function () {
        return new Promise(function (resolve) { requestAnimationFrame(function () { requestAnimationFrame(resolve); }); });
      }).then(function () { return window.BoiLoadDelivery(); }).then(function () {
        window.__boiProductDeliveryPending = false;
        initShipping(config);
      }).catch(function () {
        window.__boiProductDeliveryPending = false;
        document.getElementById('result')?.setAttribute('aria-busy', 'false');
      });
      return;
    }
    var select = document.getElementById('country-select');
    var container = document.getElementById('shipping-time-container');
    var result = document.getElementById('result');
    if (!select || !container || !result) return;
    window.__productShippingInitDone = true;

    var engine = window.BoiDelivery;
    var calendar = engine.configFromDOM();
    var state = { deadline: null, iso: null, variant: document.getElementById('productSelect')?.value || config.selectedVariantId, signature: null, inViewport: false };
    var seasonal = document.getElementById('boi-christmas-delivery');
    var seasonalText = seasonal && seasonal.querySelector('[data-boi-christmas-text]');
    var tags = Array.isArray(config.productTags) ? config.productTags : [];

    function updateFreeShipping() {
      var message = document.getElementById('product-free-shipping-message');
      if (!message) return;
      if (state.freeShippingIso === state.iso) return;
      state.freeShippingIso = state.iso;
      var premiumRow = message.closest('.boi-pdp-free-shipping');
      function content(html) {
        return premiumRow ? String(html || '').replace(/<svg\b[\s\S]*?<\/svg>/gi, '') : html || '';
      }
      if (state.iso === 'IT') {
        message.style.display = 'block';
        message.style.visibility = 'visible';
        message.innerHTML = content(config.freeShippingItaly);
      } else if (['DE', 'AT', 'FR', 'BE'].indexOf(state.iso) !== -1) {
        message.style.display = 'block';
        message.style.visibility = 'visible';
        message.innerHTML = content(config.freeShippingEuropeDeal || config.freeShippingEurope);
      } else if (['GB', 'CH', 'US', 'CA', 'CY', 'JP', 'HK', 'KR', 'PH', 'IN', 'MC', 'SM', 'TW'].indexOf(state.iso) !== -1) {
        message.style.display = 'block';
        message.style.visibility = 'hidden';
        message.innerHTML = '';
      } else {
        message.style.display = 'block';
        message.style.visibility = 'visible';
        message.innerHTML = content(config.freeShippingEurope);
      }
      if (premiumRow) premiumRow.style.visibility = message.textContent.trim() ? message.style.visibility : 'hidden';
    }

    function syncState() {
      state.iso = getSelectedIso(select);
    }

    function render() {
      var now = Date.now();
      var variant = (config.deliveryVariants || []).find(function (item) { return String(item.id) === String(state.variant); });
      var input = document.querySelector('.qty-product input[name="quantity"]');
      var widget = input && input.closest('.qty-product');
      var quantity = widget && widget.boiQuantity ? widget.boiQuantity.get().value : Number(input && input.value || 1);
      var item = Object.assign({}, variant || {}, { quantity: quantity, tags: tags });
      var estimate = engine.estimate(item, state.iso, now, calendar);
      state.deadline = estimate.deadline;
      result.setAttribute('aria-busy', 'false');
      result.hidden = !estimate.available;
      container.dataset.deliveryReason = estimate.reason || estimate.deliveryDate;
      if (estimate.available) {
        var deliveryText = engine.format(estimate.deliveryDate, document.documentElement.lang);
        if (state.signature !== deliveryText) {
          result.innerHTML = String(config.shippingTemplate || '')
            .replaceAll('[[delivery_date]]', deliveryText)
            .replaceAll('[[hours]]', '0').replaceAll('[[minutes]]', '00');
          state.signature = deliveryText;
        }
        var remaining = Math.max(0, Math.floor((state.deadline - now) / 60000));
        var hours = result.querySelector('.dl-h'), minutes = result.querySelector('.dl-m');
        if (hours) hours.textContent = String(Math.floor(remaining / 60));
        if (minutes) minutes.textContent = String(remaining % 60).padStart(2, '0');
      } else { result.textContent = ''; state.signature = null; }
      var status = engine.christmas(estimate, state.iso, now, calendar);
      if (seasonal) {
        seasonal.hidden = !status;
        seasonal.classList.toggle('boi-christmas-delivery--warning', Boolean(status && status !== 'on_time'));
        var text = status ? config.deliveryTexts[status] : '';
        if (seasonalText && seasonalText.textContent !== text) seasonalText.textContent = text;
      }
      updateFreeShipping();
      return engine.nextRender(estimate, estimate.available && Boolean(result.querySelector('.dl-h,.dl-m')) && state.inViewport);
    }
    var update = engine.watch(render, function () { return state.inViewport; });
    if (!select.querySelector('option[selected]') && config.marketIso) setSelectByIso(select, config.marketIso);
    syncState();
    update();
    refreshCountrySelect();
    select.addEventListener('change', function () { syncState(); update(); refreshCountrySelect(); });
    document.addEventListener('change', function (event) { if (event.target.matches('.qty-product input[name="quantity"]')) update(); });
    document.addEventListener('boi:pdp-variant-updated', function (event) { state.variant = event.detail && event.detail.id; update(); });
    if (window.IntersectionObserver) new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      if (visible !== state.inViewport) { state.inViewport = visible; update(); }
    }).observe(container);
  }

  function initCountrySync(config) {
    var storageKey = 'boi_shipping_country_choice_v1';
    var productSelect = document.getElementById('country-select');
    if (!productSelect) return;
    var marketIso = String(config.marketIso || getSelectedIso(productSelect) || '').toUpperCase();
    var choice;
    var syncing = false;
    try { choice = JSON.parse(localStorage.getItem(storageKey)); } catch (error) {}

    function supported(iso) {
      return Array.prototype.some.call(productSelect.options, function (option) {
        return String(option.dataset.iso || '').toUpperCase() === iso;
      });
    }

    function remember(iso, source) {
      try {
        localStorage.setItem(storageKey, JSON.stringify({ market: marketIso, country: iso, source: source }));
        localStorage.setItem('shipping_country_iso', iso);
      } catch (error) {}
    }

    function syncSideCart() {
      var sideSelect = document.getElementById('shipCountry');
      if (!sideSelect || syncing) return;
      syncing = true;
      try { setSelectByIso(sideSelect, getSelectedIso(productSelect)); }
      finally { syncing = false; }
    }

    var desiredIso = choice && choice.market === marketIso && supported(choice.country) ? choice.country : marketIso;
    setSelectByIso(productSelect, desiredIso);
    remember(getSelectedIso(productSelect), choice && choice.market === marketIso ? choice.source : 'market');
    syncSideCart();

    document.addEventListener('change', function (event) {
      var element = event.target;
      if (!(element instanceof HTMLSelectElement) || syncing) return;
      if (element.id === 'shipCountry') {
        var sideIso = getSelectedIso(element);
        if (sideIso && supported(sideIso)) {
          syncing = true;
          try { setSelectByIso(productSelect, sideIso); }
          finally { syncing = false; }
          remember(sideIso, 'cart');
        }
      } else if (element.id === 'country-select') {
        var productIso = getSelectedIso(element);
        if (productIso) {
          remember(productIso, 'product');
          syncSideCart();
        }
      }
    });

    document.addEventListener('cart:updated', syncSideCart);
    document.addEventListener('boi:cart-features-ready', syncSideCart);
  }

  function syncAvailabilityMark() {
    var status = document.querySelector('.boi-pdp-availability__status');
    var inventory = document.getElementById('product-inventory');
    if (!status || !inventory) return;
    var walker = document.createTreeWalker(inventory, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (!node.textContent.trim() || node.parentElement.closest('.availability-dot')) continue;
      status.style.setProperty('--boi-availability-color', window.getComputedStyle(node.parentElement).color);
      break;
    }
  }

  function initVariantSelectors(config) {
    var productSelect = document.getElementById('productSelect');
    if (!window.jQuery || !window.Shopify || !productSelect) return;
    var $ = window.jQuery;
    window.selectCallback = function (variant, selector) {
      if (!window.timber || typeof window.timber.productPage !== 'function') return;
      window.timber.productPage({
        money_format: config.moneyFormat,
        variant: variant,
        selector: selector,
        translations: config.translations
      });
      updatePremiumPrice(variant);
      var availability = document.querySelector('.boi-pdp-availability');
      if (availability) availability.dataset.boiAvailable = variant && variant.available ? 'true' : 'false';
      syncAvailabilityMark();
      document.dispatchEvent(new CustomEvent('boi:pdp-variant-updated', { detail: { id: variant ? variant.id : null, available: !!(variant && variant.available) } }));
    };

    if (config.hideDefaultVariant && config.product.variants.length === 1) {
      $('.selector-wrapper, .selector-wrapper-secton').hide();
      return;
    }

    if (!Shopify.OptionSelectors) throw new Error('Shopify.OptionSelectors is unavailable');
    new Shopify.OptionSelectors('productSelect', {
      product: config.product,
      onVariantSelected: window.selectCallback,
      enableHistoryState: true
    });
    if (config.enableLinkedOptions && config.product.available && config.product.options.length > 1 && Shopify.linkOptionSelectors) {
      Shopify.linkOptionSelectors(config.product);
    }
    if (config.singleOptionLabel) {
      $('.selector-wrapper:eq(0)').prepend($('<label>', { for: 'productSelect-option-0', text: config.singleOptionLabel }));
    }
    if (config.hideDefaultVariant) $('.selector-wrapper, .selector-wrapper-secton').hide();
    (config.firstAvailableOptions || []).forEach(function (option, index) {
      $('.single-option-selector:eq(' + index + ')').val(option).trigger('change');
    });
    $('.product-single .single-option-selector').each(function () {
      if (!$(this).parent().hasClass('selector-arrow')) $(this).wrap('<div class="selector-arrow">');
    });
  }

  function initFoodIcons(config) {
    var container = document.getElementById('abbinamento');
    if (!container || !Array.isArray(config.foodIcons)) return;
    config.foodIcons.forEach(function (url) {
      var image = document.createElement('img');
      image.src = url;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = 40;
      image.height = 40;
      image.style.marginBottom = '5%';
      image.style.marginRight = '10px';
      container.appendChild(image);
    });
  }

  function initTechnicalIcons() {
    var images = document.querySelectorAll('[data-boi-tech-src]');
    if (!images.length) return;
    function load(image) {
      image.src = image.getAttribute('data-boi-tech-src');
      image.removeAttribute('data-boi-tech-src');
    }
    if (!('IntersectionObserver' in window)) {
      images.forEach(load);
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        load(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '500px 0px' });
    images.forEach(function (image) { observer.observe(image); });
  }

  function initNavigation() {
    document.addEventListener('click', function (event) {
      var reviewTrigger = event.target.closest && event.target.closest('[data-boi-review-target]');
      if (reviewTrigger) {
        var reviewTarget = document.querySelector(reviewTrigger.getAttribute('data-boi-review-target'));
        if (!reviewTarget) return;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        reviewTarget.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        var focusTarget = reviewTarget.querySelector('.jdgm-rev-widg__title') || reviewTarget;
        if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex', '-1');
        window.setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, reduceMotion ? 0 : 450);
        return;
      }

      var descriptionTrigger = event.target.closest && event.target.closest('.scroll[target]');
      if (!descriptionTrigger) return;
      var descriptionTarget = document.getElementById(descriptionTrigger.getAttribute('target'));
      if (descriptionTarget) descriptionTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function init() {
    if (window.__boiProductPageInitDone) return;
    var config = readConfig();
    if (!config) return;
    window.__boiProductPageInitDone = true;
    window.currentProductId = config.productId;
    window.currentProductType = config.productType;
    window.currentProductTags = config.productTags;

    var desktopSticky = document.querySelector('.boi-desktop-sidebar-sticky');
    if (desktopSticky) desktopSticky.classList.toggle('left-sidebar-sticky', window.matchMedia('(min-width: 769px)').matches);

    function initializeFeature(name, callback) {
      try {
        callback();
      } catch (error) {
        console.error('Product page ' + name + ' initialization failed:', error);
      }
    }

    initializeFeature('country synchronization', function () { initCountrySync(config); });
    initializeFeature('shipping', function () { initShipping(config); });
    initializeFeature('variant selector', function () { initVariantSelectors(config); });
    initializeFeature('availability icon', function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(syncAvailabilityMark, { timeout: 1500 });
      else window.setTimeout(syncAvailabilityMark, 0);
    });
    initializeFeature('food icons', function () { initFoodIcons(config); });
    initializeFeature('technical icons', initTechnicalIcons);
    initializeFeature('navigation', initNavigation);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

// Lightweight delegated controls; the tooltip portal is created only on interaction.
(function () {
  'use strict';
  if (window.__boiPremiumControls) return;
  window.__boiPremiumControls = true;
  var active, panel, title, body, closeTimer, pinned = false;
  function inside(node) { return !!(node && ((active && active.contains(node)) || (panel && panel.contains(node)))); }
  function close() {
    clearTimeout(closeTimer);
    if (active) {
      active.setAttribute('aria-expanded', 'false');
      active.removeAttribute('aria-controls');
    }
    if (panel) panel.hidden = true;
    active = null;
    pinned = false;
  }
  function scheduleClose() { clearTimeout(closeTimer); if (!pinned) closeTimer = setTimeout(close, 180); }
  function position() {
    if (!active || !panel || panel.hidden) return;
    if (!active.isConnected) { close(); return; }
    var r = active.getBoundingClientRect();
    var width = document.documentElement.clientWidth;
    var height = window.innerHeight;
    var p = panel.getBoundingClientRect();
    var left = Math.max(12, Math.min(width - p.width - 12, r.left + r.width / 2 - p.width / 2));
    var top = r.bottom + 10;
    if (top + p.height > height - 12) top = Math.max(12, r.top - p.height - 10);
    panel.style.left = left + 'px';
    panel.style.top = top + 'px';
  }
  function open(trigger) {
    clearTimeout(closeTimer);
    if (active === trigger) return;
    close();
    var template = trigger.querySelector('template[data-boi-pdp-tip]');
    if (!template) return;
    if (!panel) {
      panel = document.createElement('div');
      panel.id = 'boi-pdp-tooltip';
      panel.className = 'boi-pdp-tooltip';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-labelledby', 'boi-pdp-tooltip-title');
      title = document.createElement('div');
      title.id = 'boi-pdp-tooltip-title';
      title.className = 'boi-pdp-tooltip__title';
      body = document.createElement('div');
      panel.append(title, body);
      panel.addEventListener('pointerenter', function () { clearTimeout(closeTimer); });
      panel.addEventListener('pointerleave', scheduleClose);
      document.body.append(panel);
    }
    title.textContent = trigger.dataset.boiTipTitle || trigger.getAttribute('aria-label') || '';
    body.replaceChildren(template.content.cloneNode(true));
    active = trigger;
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    trigger.setAttribute('aria-controls', panel.id);
    position();
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-boi-spec-toggle]');
    if (button) {
      var expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      button.closest('.boi-pdp-tech').querySelectorAll('[data-boi-spec-extra]').forEach(function (row) { row.hidden = !expanded; });
      button.firstChild.textContent = (expanded ? button.dataset.less : button.dataset.more) + ' ';
      return;
    }
    var trigger = event.target.closest && event.target.closest('.boi-pdp-tip-trigger');
    if (trigger) {
      event.preventDefault();
      if (active === trigger && pinned) close();
      else { open(trigger); pinned = true; }
    }
  });
  document.addEventListener('pointerover', function (event) {
    if (event.pointerType === 'touch') return;
    var trigger = event.target.closest && event.target.closest('.boi-pdp-tip-trigger');
    if (trigger && !trigger.contains(event.relatedTarget)) open(trigger);
  });
  document.addEventListener('pointerout', function (event) { if (inside(event.target) && !inside(event.relatedTarget)) scheduleClose(); });
  document.addEventListener('pointerdown', function (event) { if (active && !inside(event.target)) close(); });
  document.addEventListener('focusin', function (event) {
    var trigger = event.target.closest && event.target.closest('.boi-pdp-tip-trigger');
    if (trigger) open(trigger);
    else if (!inside(event.target)) close();
  });
  document.addEventListener('focusout', function (event) { if (inside(event.target) && !inside(event.relatedTarget)) scheduleClose(); });
  document.addEventListener('keydown', function (event) {
    if (!active) return;
    if (event.key === 'Escape') {
      var trigger = active, restore = panel.contains(document.activeElement);
      close();
      if (restore) { trigger.focus(); close(); }
    } else if (event.key === 'Tab' && !event.shiftKey && event.target === active) {
      var link = body.querySelector('a[href]');
      if (link) { event.preventDefault(); link.focus(); }
    } else if (event.key === 'Tab' && event.shiftKey && panel.contains(event.target)) {
      event.preventDefault(); active.focus();
    }
  });
  document.addEventListener('boi:pdp-price-updated', close);
  window.addEventListener('resize', position, { passive: true });
  window.addEventListener('scroll', position, { passive: true, capture: true });
})();

(function () {
  'use strict';
  var bar = document.getElementById('boi-sticky-atc');
  var button = document.getElementById('AddToCart');
  if (!bar || !button || window.__boiStickyLoader) return;
  window.__boiStickyLoader = true;
  var started = false;
  function activate() {
    if (started) return;
    started = true;
    document.body.appendChild(bar);
    var observer, offset = -1, past = false, assets, initialized = false;
    function headerOffset() {
      var bottom = 0;
      document.querySelectorAll('.site-header,.wrapper-header .is-sticky,#header-landing').forEach(function (node) {
        var r = node.getBoundingClientRect();
        if (r.top <= 1 && r.bottom > 0 && r.bottom < window.innerHeight / 2) bottom = Math.max(bottom, r.bottom);
      });
      return Math.round(bottom);
    }
    function resource(tag, url) {
      return new Promise(function (resolve, reject) {
        var node = document.createElement(tag);
        if (tag === 'link') { node.rel = 'stylesheet'; node.href = url; }
        else { node.src = url; node.async = true; }
        node.onload = resolve;
        node.onerror = function () { node.remove(); reject(new Error('Sticky assets unavailable')); };
        document.head.appendChild(node);
      });
    }
    function setPast(value) {
      past = value;
      if (initialized) { bar.dispatchEvent(new CustomEvent('boi:sticky-visibility', { detail: past })); return; }
      if (!past) return;
      if (!assets) assets = Promise.all([resource('link', bar.dataset.style), resource('script', bar.dataset.script)]).catch(function (error) { assets = null; throw error; });
      assets.then(function () {
        if (!window.BoiProductStickyInit || initialized) return;
        window.BoiProductStickyInit(bar);
        initialized = bar.dataset.ready === 'true';
        if (!initialized) return;
        bar.dispatchEvent(new CustomEvent('boi:sticky-visibility', { detail: past }));
      }).catch(function () {});
    }
    function observe() {
      var next = headerOffset();
      if (observer && next === offset) return;
      offset = next;
      if (observer) observer.disconnect();
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          if (headerOffset() !== offset) { observe(); return; }
          var entry = entries[entries.length - 1];
          setPast(!entry.isIntersecting && entry.boundingClientRect.bottom <= offset);
        }, { rootMargin: '-' + offset + 'px 0px 0px 0px', threshold: 0 });
        observer.observe(button);
      }
    }
    observe();
    window.addEventListener('resize', observe, { passive: true });
    if ('ResizeObserver' in window) {
      var header = document.querySelector('#header-landing');
      if (header) new ResizeObserver(observe).observe(header);
    }
    if (!('IntersectionObserver' in window)) {
      var scheduled = false;
      window.addEventListener('scroll', function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () { scheduled = false; setPast(button.getBoundingClientRect().bottom <= headerOffset()); });
      }, { passive: true });
      setPast(button.getBoundingClientRect().bottom <= headerOffset());
    }
  }
  window.addEventListener('scroll', activate, { once: true, passive: true });
  window.addEventListener('pageshow', function () { if (window.scrollY > 0) activate(); }, { once: true });
  if (window.scrollY > 0) activate();
})();
